import {useWindowSize} from "../../hooks/useWindowSize";

const Footer = () => {
   const size = useWindowSize()

    return (
        <div className={`bg-footer min-h-[42px] mt-auto ml-[-8px] sm:ml-[-20px] p-1 text-center`}
             style={{minWidth: (size.width)}}
        >
            <div className={'flex flex-row gap-3 items-center justify-center text-[8px] sm:text-[14px]'}>
                Copyright © {new Date().getFullYear()} Profiler Analysis V1.0
            </div>
        </div>
    )
}

export default Footer
